import { Injectable } from '@angular/core';
import { ExcelDownload } from '../models/excelDownload.model';
import { ToasterService } from '../../components/toaster/toaster.service';
import { TOASTER_TYPE } from '../../components/toaster/toaster.model';

@Injectable({
  providedIn: 'root',
})
export class ExcelDownloadService {

  constructor(private toasterService: ToasterService){}
    
  downloadBase64File(excelDownload: ExcelDownload): void {
    if (!excelDownload || !excelDownload.fileContentBase64) {
        this.toasterService.init({
            type: TOASTER_TYPE.DANGER,
            content: 'Failed to generate the Excel File.',
          });
      return;
    }
    const binaryData = atob(excelDownload.fileContentBase64);
    const byteNumbers = new Uint8Array(binaryData.length);
    for (let i = 0; i < binaryData.length; i++) {
      byteNumbers[i] = binaryData.charCodeAt(i);
    }
    const blob = new Blob([byteNumbers], { type: excelDownload.contentType });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = excelDownload.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
